import 'remixicon/fonts/remixicon.css';
import axios from 'axios';
import { useAppDispatch } from '../../store/Hooks';
import { useParams } from "react-router-dom";
import { TeacherData } from '../../store/viewmodels/TeacherViewModel';
import { useAppSelector } from '../../store/Hooks';
import { Student } from '../../store/viewmodels/StudentViewModel';
import { Task } from '../../store/viewmodels/TaskViewModel';
import { useState } from 'react';
import EditKeysModal from './EditKeysModal';
import ModalWrapper from '../utils/modal/ModalWrapper';
import { Itemset, ItemsetResult } from '../../store/viewmodels/ItemsetViewModel';
import { getLogos } from '../../utils/TaskContentServices';
import { deleteStudent, removeStudentFromState } from '../../store/TeacherSlice';


interface StudentInfoParams {
    studentId?: string,
}

interface StudentInfoProps {
    used: boolean
}

function StudentInfo(props: StudentInfoProps) {

    let info: JSX.Element = <></>
    let { studentId } = useParams<StudentInfoParams>();
    const teacherData: TeacherData = useAppSelector(state => state.teacherData);
    const user = teacherData.isAuthenticated ? teacherData.teacher : null;
    let allStudents: Student[] = user ? user.students : [];
    let selectedStudentIndex = allStudents.findIndex(i => i.id === Number(studentId));
    let selectedStudent: Student = allStudents[selectedStudentIndex];
    let studentsTasks: Task[] = selectedStudent?.task_access_list;
    const [isModalVisible, setModalVisible] = useState(false);
    const dispatch = useAppDispatch();

    if (!selectedStudent) return <div> Valitse oppilas listasta.</div>

    const showModal = () => {
        setModalVisible(wasModalVisible => !wasModalVisible);
    }

    const handleDelete = (event: any) => {
        let studentId: number = selectedStudent.id
        //let URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/students/' + studentId + '/' : '/api/students/' + studentId + '/'
        dispatch(deleteStudent(studentId))
            .then(() => {
                dispatch(removeStudentFromState(studentId))
            }, (error) => {
                console.log(error)
            }
            )
        // axios.delete(URL)
        //     .then((response) => {
        //         dispatch(removeStudentFromState(studentId))
        //         console.log(response)
        //     }, (error) => {
        //         console.log(error)
        //     })
    }

    let content = <EditKeysModal close={showModal} student={selectedStudent} />
    let taskList = <TaskList tasks={studentsTasks} itemsets={selectedStudent.active_item_sets} />

    const hidden = props.used ? "hidden" : "";

    if (Number(studentId) < 0 || !selectedStudent) {
        info = (
            <div>
                <div>
                    Valitse näytettävä opiskelija listasta.
                </div>
            </div>);
    }
    else {
        info = (
            <div className="p-8 w-full">
                {<ModalWrapper isVisible={isModalVisible} onBackdropClick={showModal} content={content} type={"studentInfo"} />}
                <div className="md:flex md:flex-grow border-b border-gray-200 pb-2">
                    <div className="md:flex md:flex-grow">
                        <h1 className="text-2xl font-extrabold text-gray-900">{selectedStudent.identification}</h1>
                        <h1 className="md:ml-4 text-2xl text-gray-500">{selectedStudent.username}</h1>
                    </div>
                </div>
                <div>
                    <h2 className="mt-4 text-xl font-bold text-gray-700">Tehtävät</h2>
                    {taskList}
                    <div className="flex mt-5">
                        <button type="button" onClick={showModal} className={"mr-1 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"}>Muokkaa tietoja</button>
                        <button type="button" onClick={handleDelete} className={"ml-1 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 " + hidden}>Poista tunnus</button>
                    </div>
                </div>
            </div>
        );
    }
    return info;
}

interface TaskListProps {
    tasks: Task[],
    itemsets: ItemsetResult[];
}

function TaskList(props: TaskListProps): JSX.Element {
    if (props.tasks.length === 0) {
        return (
            <div className="">
                Oppilaalla ei ole tehtäviä.
            </div>
        );
    }
    let items: JSX.Element[] = [];
    let itemsetIds: number[] = props.itemsets.map(item => item.id);

    for (let i: number = 0; i < props.tasks.length; i++) {
        items.push(<TaskListItem key={"taskListItem" + props.tasks[i].id} task={props.tasks[i]} itemsetIds={itemsetIds} />);
    }

    return (
        <div>
            {items}
        </div>
    );

}

interface TaskListItemProps {
    task: Task,
    itemsetIds: number[]
}

function TaskListItem(props: TaskListItemProps): JSX.Element {

    let theme = props.task.theme;
    let theme_logo = props.task.logo?.logo;

    let name = theme === "NONE" ? props.task.name.toUpperCase() : theme.toUpperCase();
    let altText = theme === "NONE" ? "logo" : theme;
    let vikkeAddress = "https://vikke.nmi.fi/wp-content/uploads/2021/05/Vikke_symboli_800px-768x614.png";
    let imgElement = theme_logo ? <img className="py-1 my-1 pl-1 ml-1 pr-2 mr-2 w-20 h-auto" src={getLogos(theme_logo)} alt={altText} /> : <img className="py-1 my-1 pl-1 ml-1 pr-2 mr-2 w-20 h-auto" src={vikkeAddress} alt={"Vikke"} />;
    let taskHeaderElement = (
        <div className="flex">
            {imgElement}
            <div className="my-auto ">
                {name}
            </div>
        </div>);

    let itemsetItems: JSX.Element[] = [];
    for (let i: number = 0; i < props.task.itemsets.length; i++) {
        if (props.itemsetIds.includes(props.task.itemsets[i].id)) {
            itemsetItems.push(<ItemsetListItem key={"itemsetListItem" + props.task.itemsets[i].id} itemset={props.task.itemsets[i]} />)
        }
    }

    return (
        <div className="md:grid md:grid-cols-2 border-b-2 border-gray-200 my-1 py-1">
            <div>
                {taskHeaderElement}
            </div>
            <div className="my-auto w-full">
                {itemsetItems}
            </div>
        </div>
    );
}

interface ItemsetListItemProps {
    itemset: Itemset
}

function ItemsetListItem(props: ItemsetListItemProps): JSX.Element {
    let color = "";
    let name = props.itemset.name;
    if (!props.itemset.ready_to_publish) {
        color = " text-gray-300";
        name = name + " (ei käytössä)"
    }
    return (
        <div className={"block w-full md:ml-8 " + color}>{name}</div>
    );

}

export default StudentInfo;